(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7154],{

/***/ 53945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/views/Marketing/Blog/components/BlogPage/index.tsx
var BlogPage = __webpack_require__(32526);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Blog/marketing/depop-scams/index.tsx







function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogPage/* default */.Z, {
      author: "OneShop Team",
      dateTime: "2022-04-08",
      tag: "Depop",
      title: "Sellers Beware: Depop Scams You Should Watch Out For",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Depop is a vast marketplace where you can buy and sell anything from clothing to electronics. There are over 100 million items listed on Depop, with 90% of users aged 26 and under. Depop is known to have relaxed requirements. As young as 13 years old can register in Depop, make an account and start buying or selling.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["This is why scammers and hackers are also rampant in the app. With all these precautions, how can sellers ensure safe transactions inside Depop? We list down common scams sellers encounter and how to spot them, ways to avoid being scammed, and other information in this blogpost!", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "3 Common Scams Sellers Encounter on Depop "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Depop is a popular app used by people worldwide looking for bargains on fashion or electronics they like or need. But what many don't know is that there are many ways you can be taken advantage of while using this app. Here are some of the most common scams sellers should watch out for.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
            children: "Drop Shipping Scams"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            children: ["Dropshipping is a process where a reseller lists \"on-trend\" items on Depop and sells them at a higher price. When a customer buys that item, the reseller will purchase it on the website selling it cheaply like wish.com or aliexpress with the buyer's shipping address, pocketing the price difference.", ' ']
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            children: ["Drop-shipping practice is not allowed in Depop. But if you navigate the Depop App, you can see many listings with stock photos and generic product descriptions. Some drop shippers even steal other sellers' pictures and product descriptions and list them as their own.", ' ']
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            children: ["This can confuse buyers. Some buyers may also lose interest and confidence in buying the item. Most drop shippers buy items with poor quality or knock-offs, causing the reputation of resellers selling high-quality and authentic items.", ' ']
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
            children: "What Can You Do? "
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                children: "Report it to Depop."
              }), " If you spot someone stealing your listing photos, have it reported to Depop immediately. Depop will investigate the listing, and you can expect a response from them within 24 hours.", ' ']
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                children: "Put a Trademark."
              }), " Although this can cause extra work, putting trademarks on your listing photos can prevent scammers from stealing your pictures and instill confidence in your customers.", ' ']
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                children: "Avoid Using Stock Photos."
              }), " If you can, try to avoid using stock photos and take photos of the actual item. Scammers often use stock photos, and customers will find it hard to tell the dissimilarity. Also include all other relevant information and a close-up shot of any blemishes, stains, or holes in your item.", ' ']
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
            children: "Other Shipping Addresses"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            children: ["One of the most common scams sellers encounter is buyers requesting a change in shipping addresses. While this looks like harmless requests, where the customer might have forgotten to update their shipping address on the platform, some unscrupulous people are using this to scam Depop sellers.", ' ']
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "The Depop Seller Protection states that the seller must ship the sold item to the address indicated in their sales receipt. Even if you are not using Depop's shipping and decides to send it on your own, you must still enter an accurate tracking with the shipping address."
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            children: ["If the seller sends the item to a different address, they will lose the seller protection. This also means that when the buyer files an \"item did not receive\" claim, the claim will be in the buyer's favor. The seller will be at a loss without the product and profit.", ' ']
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
            children: "Elaborate Online Scams"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            children: ["Many scammers are also finding new and creative ways to scam other buyers and sellers just to get what they want. While Depop's security is upgrading and innovating continuously, scammers are still finding ways to scam Depop users.", ' ']
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            children: ["One prevalent scam happening in Depop right now is the elaborate online scams. These scams involve three people, the scammer, the buyer, and the seller. The scam may look like this\u2013 the scammer will ask the buyer for payment. After the payment has been confirmed, they will message the seller asking to change the shipping address elsewhere. So, the seller will send the item to the scammer's address while the buyer waits for nothing. When the buyer opens an \"item not received\" dispute, Depop will favor them, and the seller is at a loss without the product and the profit.", ' ']
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Items Targeted By Scammers"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Let us dive deeper into what types of items attract scammers. Is a typical, everyday $10 sweater enough to lure scammers, or are they aiming for high-value items? For starters, scammers are looking for high demands, \"on-trend,\" and easy-to-sell types of items. Most would probably not waste their time scamming people for small purchases or anything less than $20.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Here are categories often targeted by scammers:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Designer Items"
          }), " - Some of the most common brands frequently targeted by scammers are Louis Vuitton, Dior, Chanel, Gucci, and other luxury items.", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "High-End Streetwear"
          }), " - Aside from designer items, scammers are also looking for high-end streetwear brands such as highly anticipated collabs, rare sneakers, jackets, etc."]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Electronics and Gaming"
          }), " - Some of the hard-to-get gaming consoles like the Nintendo Switch, and Apple products like the iPhone and Airpods, are easy targets of scammers.", ' ']
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Suppose you sell anything under these categories or have an item with a high value on it. You're more likely to encounter scammers asking for more details or initiating outside transactions on Depop.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["As a seller, it's vital to know how to spot scammers to avoid being scammed quickly. We list down five signs to look out for and tips on avoiding getting scammed, especially for new Depop sellers.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Signs to Spot a Scammer "
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "90% of Depop users are aged 26 and under. While this helps many teenagers de-clutter their closets and make some money, scammers also found this as an easy way to scam Depop users."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Remember that scammers are not just common on Depop. There are also scammers on other e-Commerce platforms like Poshmark and eBay. Spotting a scammer from a legitimate buyer can save you time and money. Here are signs sellers should look out for to spot a scammer.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
            children: "Accounts with Incomplete Details"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            children: ["One easy way to spot a scammer from legitimate buyers is by looking at their profile. Do they have a profile picture of themselves? Are they using their real name? Do their accounts have reviews?", ' ']
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            children: ["While you can give the benefit of the doubt to some users, especially those new to Depop, you should also be wary about users with no photos, weird alphanumeric names, and zero reviews, especially if they are asking for a high-valued item. If you feel something is off, you can simply decline their offer or have them reported to Depop so they can investigate the account.", ' ']
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
            children: "Buyers Initiating Conversations Outside Depop"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            children: ["Another common red flag on Depop is when a buyer sends you a private message after you list an item. The message usually looks like this\u2013 \"Hello! I am interested in your items, please message me at w h a t s a p p @username1234 thanks!\" or they left an email address or personal number instead of transacting inside the platform.", ' ']
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            children: ["If you agree to talk with them using these channels and transact with them outside Depop and they turn out to be a scammer, then it will become an expensive lesson learned experience. You cannot also file any seller claims as transacting outside Depop excludes you from benefiting from the Seller Protection program.", ' ']
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
            children: "Buyers Requesting to Change Shipping Address"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "Some buyers may have forgotten to update their shipping addresses on their Depop account or would like to send their purchased item directly to their family or friends as a gift. These are the common reasons customers request to ship their items to a different address from their billing address."
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            children: ["Unfortunately, scammers also use these requests to scam sellers. If you encounter these requests, simply decline the offer. You can say that you are only allowed to ship the item to the address written on their accounts. And even if you are not using Depop shipping, you still have to follow Depop shipping policy. In this way, you can ensure your product and income are protected.", ' ']
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
            children: "Buyers Asking for PayPal or Direct Bank Payments "
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            children: ["One of the most common ways scammers deceive their victims is by sending them private messages saying they are interested in your item. However, they find the Depop fee unreasonable, so they would like to pay directly to your bank account or via PayPal's \"Family and Friends\" to save some money.", ' ']
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            children: ["Some may say they cannot trust the seller and suggest paying 50% then the remaining 50% once they receive the item. Some sellers agree to this set-up only to be blocked after sending the item. These schemes mainly target new sellers who are not well aware of how seller protection works. Keep in mind that all transactions and payments made outside Depop automatically exclude you from Depop Seller Protection.", ' ']
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Tips on How to Avoid Getting Scammed "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Even if scammers are flooding Depop and other marketplaces, there are still ways to prevent them. Here are some tips on how sellers can avoid getting scammed:", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Check Your Buyer's Profile "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Run a quick check on your buyer's profile, especially if they are interested in a high-valued item. Are they using their real name or a strange username with many numbers? Do they have photos? Are they Depop resellers as well?", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["By checking their profile, you can already tell a lot about themselves. If something is off, or if the customer is being rude and is asking unreasonable demands. You can simply decline the transaction and communicate with other buyers.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Don't Communicate Outside Depop"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["If you received a private message asking to communicate on Instagram, WhatsApp, and other channels. Decline it immediately. You must only communicate via the Depop App to keep your seller's protection.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Don't Accept Direct Payments"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Remember, all payments must be made inside the Depop App. Decline any offers asking to pay directly to your bank account or PayPal. Even if the customer says they want to save extra money or are willing to pay via PayPal's Goods and Services, decline still.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Don't Ship to a Different Address "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Only ship their purchased item to the shipping address indicated in their Depop and PayPal account. Even if you are sending on your own and not using the Depop shipping, you still have to ship it to the indicated shipping addresses on their Depop and PayPal accounts.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Make Sure You're Protected "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["To be covered by seller protection, all sales must be made using Depop's \"BUY\" button. All direct payments, prohibited items, meet-ups, and trades outside Depop exclude you from benefiting from the seller protection.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Build Customer Trust with OneShop "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Many scammers find new and creative ways to take advantage of sellers in Depop, Poshmark, eBay, and other e-commerce platforms. As a seller, you must be wary and be equipped with the knowledge to prevent these dishonest people from taking advantage of your products and money.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["One way to avoid getting scammed is by being cautious with whom you're transacting while building your customers' trust. With OneShop, you can now have more time to close deals and make money while keeping your account's operations at bay.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Our OneShop tool lets you customize and automate listing tasks such as liking, sharing, following, and re-listing. It can act as your 24/7 virtual assistant with a human-like activity to avoid account restrictions or being stuck in share jail.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["You can easily cross-list from Poshmark to Depop, Mercari, and other platforms (eBay soon, too!) Plus, data and sales analytics are always free so that you can improve your campaigns and promotions more.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Improve how you work, and save more time doing things you love! Try it today,", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "https://tools.oneshop.com/signup",
          children: "register for free"
        }), ", and see the difference OneShop provides to your reselling business.", ' ']
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ./src/pages/blog/depop-scams.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "Sellers Beware: Depop Scams You Should Watch Out For"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "Discover common scams encountered by Depop Sellers and how to avoid them!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://tools.oneshop.com/blog/depop-scams"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://tools.oneshop.com/blog/depop-scams"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "Sellers Beware: Depop Scams You Should Watch Out For"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: "Discover common scams encountered by Depop Sellers and how to avoid them!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=4"
      }, 'og-image'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:published_time",
        content: "April 8th, 2022"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:modified_time",
        content: "April 8th, 2022"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:tag",
        content: "Depop"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:publisher",
        content: "https://www.facebook.com/oneshopcompany"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Page, {})]
  });
}

/***/ }),

/***/ 55614:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/depop-scams",
      function () {
        return __webpack_require__(53945);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,275,9774,2888,179], function() { return __webpack_exec__(55614); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);